<template>
  <div class="modal fade" id="ViewEMIRecord">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            <button @click="printViewEMIRecord()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
        </div>
        <div class="modal-body" id="printViewEMIRecord">
            <div class="row">
            
              <div class="col-md-12">
                <!-- Profile Image -->
                <div class="card card-primary card-outline">
                  <div class="card-body box-profile">
                    <table class="table table-condensed" style="border-width:2px;">
                      <thead tyle="border-width:2px;">
                        <td tyle="border-width:2px;"><img :src="logo" height="100"></td>
                        <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                          <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                          </small></h4></td>
                      </thead>
                      <tbody>
                        <td>
                          <strong> Branch : <i v-if="memberloanplan.branch">{{memberloanplan.branch.name}} </i><br>
                          Application No : {{memberloanplan.applicationNo}}<br>
                          Total Amt : {{memberloanplan.totalAmt}} <br>
                          Received Amt : {{memberloanplan.receivedAmt}}
                          </strong>
                        </td>
                        <td class="text-right"><strong v-if="memberloanplan.member">Cust Name : {{memberloanplan.member.name}} <br>
                          Cust Code : {{memberloanplan.member.code}} <br>
                          Cust Mobile : {{memberloanplan.member.mobile}}</strong>
                        </td>
                      </tbody>
                    </table>
                    <h2 class="text-center">LOAN EMI RECORDS</h2>
                    <table class="table table-condensed" style="border-width:2px;">
                      <thead>
                        <td>Sr.</td>
                        <td>EMI Date</td>
                        <td>Principal</td>
                        <td>Interest</td>
                        <td>Total</td>
                        <!-- <td>Adjustment</td> -->
                        <td>Balance</td>
                        <td>Received</td>
                        <td>Arrear</td>
                        <td>Advance</td>
                        <td>Status</td>
                      </thead>
                      <tbody>
                        <tr v-for="(ro, index) in rows" :key="index">
                          <td>{{index + 1}}</td>
                          <td><i v-if="ro.emiDate">{{ro.emiDate | myDate}}</i></td>
                          <td><i v-if="ro.principal">{{ro.principal}}</i></td>
                          <td><i v-if="ro.intrest">{{ro.intrest}}</i></td>
                          <td><i v-if="ro.total">{{ro.total}}</i></td>
                          <!-- <td><i v-if="ro.adjustment">{{ro.adjustment}}</i></td> -->
                          <td><i v-if="ro.balance">{{ro.balance}}</i></td>
                          <td><i v-if="ro.received">{{ro.received}}</i></td>
                          <td><i v-if="ro.arrear">{{ro.arrear}}</i></td>
                          <td><i v-if="ro.advance">{{ro.advance}}</i></td>
                          <td><i v-if="ro.status">{{emistatus(ro.status)}}</i></td>
                        </tr>
                      </tbody>
                    </table>
                    <p style="page-break-before: always;"></p>
                    <table class="table table-condensed" style="border-width:2px;">
                      <thead tyle="border-width:2px;">
                        <td tyle="border-width:2px;"><img :src="logo" height="100"></td>
                        <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                          <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                          </small></h4></td>
                      </thead>
                      <tbody>
                        <td>
                          <strong> Branch : <i v-if="memberloanplan.branch">{{memberloanplan.branch.name}} </i><br>
                          Application No : {{memberloanplan.applicationNo}}<br>
                          Total Amt : {{memberloanplan.totalAmt}} <br>
                          Received Amt : {{memberloanplan.receivedAmt}}
                          </strong>
                        </td>
                        <td class="text-right"><strong v-if="memberloanplan.member">Cust Name : {{memberloanplan.member.name}} <br>
                          Cust Code : {{memberloanplan.member.code}} <br>
                          Cust Mobile : {{memberloanplan.member.mobile}}</strong>
                        </td>
                      </tbody>
                    </table>
                    <h2 class="text-center">CUSTOMER PAYMENT RECORDS</h2>
                    <table class="table table-sm table-bordered table-hover">
                      <thead style="background-color: #d6dddd;">
                        <tr style="border-width:2px">
                          <th style="border-width:2px">Sr.</th>
                          <th style="border-width:2px">Type</th>
                          <th style="border-width:2px">Pay Date</th>
                          <th style="border-width:2px">Amount</th>
                          <th style="border-width:2px">Received By</th>
                          <th style="border-width:2px">Mode</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(payRecord, index) in rowsMemberCollections" :key="index" style="border-width:2px">
                          <td style="border-width:2px">{{ (index + 1) }}</td>
                          <td style="border-width:2px"><i v-if="payRecord.type === 'panulty'">penalty</i><i v-else>{{ payRecord.type }}</i></td>
                          <td style="border-width:2px">{{ payRecord.paymentDate | myDate}}</td>
                          <td style="border-width:2px">{{ payRecord.amt }}</td>
                          <td style="border-width:2px"><span v-if="payRecord.received_by">{{ payRecord.received_by.name }}</span></td>
                          <td style="border-width:2px"><span v-if="payRecord.branch_ledger">{{ payRecord.branch_ledger.ledger.name }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
            <!-- /.col -->
            
            </div>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PrintEMIRecords',
  props: ['rows', 'getCompanyRecord', 'logo', 'memberloanplan', 'rowsMemberCollections'],
  methods: {
    emistatus (status) {
      if (status === 'sattle') {
        return 'settle'
      } else {
        return status
      }
    },
    printViewEMIRecord () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printViewEMIRecord').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:2px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  }
}
</script>
<style scoped>
  @media print {
      div { 
        /* float: none !important; */
        /* position: static !important;  */
        display: inline; 
        /* box-sizing: content-box !important; */
      }
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .content {
    padding: 0px;
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// PrintEMIRecords.vue?ac09e658